module.exports = __webpack_public_path__ + "assets/share.7133346c.svg";